// removed by extract-text-webpack-plugin
module.exports = {"grid":"_3C7FZuZh","tile":"_3YR7xCf2","img":"TdXshi3m","active":"_2gfo8jbv"};


//////////////////
// WEBPACK FOOTER
// ./app/orders/components/category-selection/category-selection.styles.scss
// module id = 686
// module chunks = 0